<template>
	<div class="leftscroll">
		<div class="first-page">
			<svg-icon class-name="dashboard" icon-class="dashboard" />
			<span>首页</span>
		</div>
		<el-scrollbar wrap-class="scrollbar-wrapper" style="height: 80%;" class="first_navbar">
			<el-menu :default-active="activeMenu" 
					:unique-opened="true" 
					:collapse-transition="false" 
					:text-color="variables.menuText1"
					mode="vertical" 
					style="margin-top: 64px;background-color:#e4f3fb!important;border-right:0px solid #e6e6e6;">
					
				<sidebar-item v-for="(route, index) in permission_routes[$store.state.topNav].children" 
					:key="route.path" :item="route"
					:base-path="route.path" 
					class="lefttwo" :change="changeData"></sidebar-item>
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
	import {mapGetters,mapState} from "vuex";
	import Logo from "./Logo";
	import SidebarItem from "./Sidebaritem_left.vue";
	import variables from "@/assets/styles/variables.scss";
	export default {
		components: {
			SidebarItem,
			Logo
		},
		data() {
			this.onlyOneChild = null
			return {
				msg: '首页',
			}
		},
		props:{
			changeData:Boolean
		},
		computed: {
			...mapState(["settings"]),
			...mapGetters(["permission_routes", "sidebar"]),
			activeMenu() {
				const route = this.$route;
				const {
					meta,
					path
				} = route;
				// if set path, the sidebar will highlight the path you set
				if (meta.activeMenu) {
					return meta.activeMenu;
				}
				return path;
			},
			showLogo() {
				return this.$store.state.settings.sidebarLogo;
			},
			variables() {
				return variables;
			},
			isCollapse() {
				return !this.sidebar.opened;
			}
		},
		watch: { // 路由监听：监听路由的变化，从而做出相应操作
			$route: {
				immediate: true, // 一旦监听到路由的变化立即执行
				handler(to, from) { // 回调函数，两个参数，to：当前的组件，from：上一个组件
					var watchName=to.matched[0].name;
					this.watchRoute(watchName);
				}
			}
		},
		methods: {
			watchRoute(watchName){
				var watchName=watchName;
				for(let i in this.permission_routes){
					if(watchName==this.permission_routes[i].name){
						var watchObj=this.permission_routes[i];
						this.$store.commit('newTopNav', i);
					}
				}
			}
		}
	};
</script>
<style>
	.first-page {
		font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;
		font-weight: 700;
		color: #1C81D9;
		position: absolute;
		margin: 22px 35px;
	}

	.first-page span {
		float: left;
	}

	.first-page svg {
		float: left;
		margin-top: -2px !important;
		margin-left: 0px !important;
		font-size: 20px;
	}
.leftscroll {
	margin-top:-3px!important;
}
	.el-scrollbar {
	    overflow-y: auto;
	    padding-bottom: 20px;
	}
	.leftscroll .el-scrollbar__wrap {
		/* overflow: hidden scroll; */
		overflow: hidden;
		overflow-y: auto;
		height: auto;
	}

	.first-top {
		position: fixed;
		z-index: 100;
		width: 231px;
		background-color: #e4f3fb;
		top: 200px;
		padding-bottom: 20px;
	}

	.first-top span {
		font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;
		font-weight: 700;
		color: #1C81D9;
	}

	.first-top svg {
		color: rgb(28, 129, 217);
	}
</style>
